import React from "react";
import { Dimensions, StyleSheet, ScrollView, KeyboardAvoidingView, View, Text } from "react-native";
import LoginForm from "./LoginForm";
import { OiqiaQIcon } from "../../components/Icons";
import { MD3Theme, useTheme } from "react-native-paper";
import { SafeAreaView } from "react-native-safe-area-context";

export default function Login() {
  const theme = useTheme();
  const styles = styleGen(theme);

  return (
    <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
      <KeyboardAvoidingView
        style={{ flex: 1 }}
        behavior="padding"
      >
        <ScrollView
          contentContainerStyle={styles.container}
          keyboardDismissMode="interactive"
        >
          <OiqiaQIcon width={Dimensions.get("screen").height / 6} height={Dimensions.get("screen").height / 6} />          
          <LoginForm />
        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
}

const styleGen = (theme: MD3Theme) => StyleSheet.create({
  container: {
    minHeight: Dimensions.get("screen").height,
    alignItems: "center",
    backgroundColor: theme.colors.background,
    paddingVertical: "20%",
    gap: 35
  },
});
